enum StoreName {
    ROOT = 'root',
    CONFIG = 'config',
    DASHBOARD = 'dashboard',
    AUTH = 'auth'
}

export default StoreName;
